/**
 * Todos los textos de la consola, en español neutro. Los componentes no escriben textos: los toman de
 * aquí. Un texto que depende de datos es una función.
 */
import { plural } from "../lib/formato";

export const es = {
  marca: {
    nombre: "BVL Chile",
    consola: "Administración del portal",
    titulo: (pagina: string) => `${pagina} · Administración del portal BVL`,
  },
  navegacion: {
    etiqueta: "Principal",
    usuarios: "Usuarios",
    instituciones: "Instituciones",
    auditoria: "Auditoría",
    saltar: "Saltar al contenido",
    salir: "Salir",
    menuCuenta: "Menú de la cuenta",
  },
  pie: {
    sitio: "Consola interna de BVL · no es visible para los clientes",
    horas: "Las horas se muestran en hora de Chile.",
    empresa: "Bon Voyage Logistics Chile",
    por: "by",
    simplgo: "SimplGo",
    derechos: (anio: number) => `© ${anio} Todos los derechos reservados.`,
  },
  demo: {
    aviso: "Modo demostración · datos de prueba sintéticos · no se envía ningún correo",
  },
  general: {
    cargando: "Cargando…",
    errorTitulo: "No pudimos cargar la información",
    errorTexto: "Revise su conexión e intente de nuevo.",
    reintentar: "Reintentar",
    cancelar: "Cancelar",
    guardando: "Guardando…",
    cargarMas: "Cargar más",
    nunca: "Nunca",
    sinMotivo: "Sin motivo",
    volver: "Volver a la lista",
    errorAccion: "No pudimos completar la acción. Intente de nuevo.",
    errorSinPermiso: "Su usuario ya no tiene el permiso de administración del portal.",
  },
  tabla: {
    ordenarPor: "Ordenar por",
    predeterminado: "Orden de la pantalla",
    ascendente: (columna: string) => `${columna}, ascendente`,
    descendente: (columna: string) => `${columna}, descendente`,
  },
  sesion: {
    tituloIngreso: "Administración del portal de clientes",
    textoIngreso:
      "Ingrese con su usuario de SimplGo. Solo pueden entrar las personas de BVL con el permiso de administración del portal.",
    ingresar: "Ingresar con mi usuario de BVL",
    redirigiendo: "Llevándolo a la página de ingreso…",
    completando: "Completando el ingreso…",
    errorRetornoTitulo: "No pudimos completar el ingreso",
    errorRetornoTexto: "El enlace venció o se abrió en otra pestaña. Vuelva a ingresar.",
    cancelado: "Cerró el ingreso antes de terminar. Puede volver a intentarlo.",
    volverAIngresar: "Volver a ingresar",
    sinPermisoTitulo: "Su usuario no tiene el permiso de administración del portal",
    sinPermisoTexto: (correo: string) =>
      `Ingresó como ${correo}. Para administrar el portal de clientes hace falta un correo @bvlchile.com y el grupo «portal-admin»; pídalo al equipo de SimplGo.`,
    terminoTitulo: "Su sesión terminó",
    terminoTexto: "Por seguridad, la sesión vence. Vuelva a ingresar para seguir.",
  },
  estados: {
    invitado: "Invitado",
    activo: "Activo",
    suspendido: "Suspendido",
    baja: "Dado de baja",
  },
  perfiles: {
    operaciones: "Operaciones",
    finanzas: "Finanzas",
    ayudaOperaciones: "Ve embarques, documentos y avisos. No ve facturas ni cargos.",
    ayudaFinanzas: "Ve todo lo de operaciones, además de facturas, cargos y estado de cuenta.",
  },
  relaciones: {
    propia: "Su empresa",
    mismo_grupo: "Mismo grupo",
    agente_aduanas: "Agente de aduanas",
    casa_matriz: "Casa matriz",
    otra: "Otra",
  },
  usuarios: {
    titulo: "Usuarios",
    subtitulo: "Personas de los clientes con acceso al portal. Solo BVL invita, suspende o da de baja.",
    invitar: "Invitar usuario",
    buscar: "Buscar usuario",
    buscarAyuda: "Nombre, correo o código de empresa",
    filtro: "Estado",
    todos: "Todos",
    columnaPersona: "Persona",
    columnaEmpresas: "Empresas",
    columnaEstado: "Estado",
    columnaIngreso: "Último ingreso",
    columnaInvitado: "Invitado",
    sinEmpresas: "Sin empresas",
    vacioTitulo: "Aún no hay usuarios",
    vacioTexto: "Invite a la primera persona de un cliente para que pueda entrar al portal.",
    sinResultadosTitulo: "Ningún usuario coincide",
    sinResultadosTexto: "Pruebe con otra parte del nombre, el correo o el código de la empresa.",
    cuantos: (n: number) => plural(n, "usuario", "usuarios"),
    quitarFiltros: "Quitar la búsqueda y el filtro",
    invitadoPor: (quien: string, cuando: string) => `${cuando} · por ${quien}`,
  },
  invitar: {
    titulo: "Invitar usuario",
    subtitulo:
      "La persona recibe un correo de BVL con su contraseña temporal, válida por 7 días. Al primer ingreso elige la suya.",
    correo: "Correo",
    nombre: "Nombre y apellido",
    empresa: "Empresa",
    empresaAyuda: "Solo aparecen las instituciones habilitadas en el portal.",
    elegirEmpresa: "Elija una empresa",
    perfil: "Perfil en esa empresa",
    enviar: "Revisar e invitar",
    confirmarTitulo: "¿Enviar la invitación?",
    confirmarTexto: (correo: string, empresa: string) =>
      `Se enviará un correo real a ${correo} y la persona podrá ver la información de ${empresa}.`,
    confirmar: "Sí, enviar la invitación",
    enviando: "Enviando…",
    listo: (correo: string) => `Invitación enviada a ${correo}.`,
    sinInstitucionesTitulo: "No hay instituciones habilitadas",
    sinInstitucionesTexto: "Antes de invitar, habilite en Instituciones la empresa del cliente.",
    irAInstituciones: "Ir a Instituciones",
    errores: {
      correo: "Escriba un correo válido, por ejemplo nombre@empresa.cl",
      nombre: "Escriba el nombre de la persona",
      empresa: "Elija la empresa de la persona",
    },
  },
  ficha: {
    datos: "Datos",
    correo: "Correo",
    estado: "Estado",
    invitadoPor: "Invitado por",
    invitadoEn: "Invitado el",
    ultimoIngreso: "Último ingreso",
    noEncontradoTitulo: "Ese usuario no existe",
    noEncontradoTexto: "Puede que el enlace esté incompleto. Búsquelo en la lista.",
    accesos: "Empresas que puede ver",
    accesosAyuda: "El perfil se elige por empresa. Una empresa relacionada siempre lleva el motivo.",
    columnaEmpresa: "Empresa",
    columnaPerfil: "Perfil",
    columnaRelacion: "Relación",
    columnaConcedido: "Concedido",
    columnaEstado: "Estado",
    acciones: "Acciones",
    quitar: "Quitar",
    quitarTitulo: (empresa: string) => `¿Quitar ${empresa}?`,
    quitarTexto: "La persona deja de ver esa empresa en menos de 2 minutos. Queda en el historial.",
    confirmarQuitar: "Sí, quitar",
    cambiarPerfil: (empresa: string) => `Perfil en ${empresa}`,
    sinAccesosTitulo: "No ve ninguna empresa",
    sinAccesosTexto: "Mientras no tenga una empresa, la persona no ve nada en el portal.",
    quitadas: (n: number) => `Ver ${plural(n, "empresa quitada", "empresas quitadas")}`,
    agregar: "Agregar empresa",
    agregarTitulo: "Agregar una empresa",
    empresa: "Empresa",
    relacion: "Relación con su empresa",
    motivo: "Motivo",
    motivoAyuda: "Obligatorio si no es su empresa. Explique por qué la ve, para quien lo revise después.",
    motivoFalta: "Escriba el motivo: no es su empresa",
    conceder: "Agregar",
    todasConcedidas: "Ya ve todas las instituciones habilitadas.",
    cuenta: "Cuenta",
    cuentaAyuda: "Toda acción queda registrada con su correo.",
    historial: "Historial",
    historialAyuda: "Lo que hizo en el portal y lo que BVL hizo con su cuenta. Hora de Chile.",
    historialVacio: "Todavía no hay actividad.",
    accionesCuenta: {
      "reenviar-invitacion": {
        boton: "Reenviar invitación",
        titulo: "¿Reenviar la invitación?",
        texto: (correo: string) => `Se enviará otra vez el correo con una contraseña temporal nueva a ${correo}.`,
        confirmar: "Sí, reenviar",
        listo: "Invitación reenviada.",
      },
      suspender: {
        boton: "Suspender",
        titulo: "¿Suspender a este usuario?",
        texto: () => "No podrá ingresar y sus sesiones se cierran. Se puede reactivar después.",
        confirmar: "Sí, suspender",
        listo: "Usuario suspendido.",
      },
      reactivar: {
        boton: "Reactivar",
        titulo: "¿Reactivar a este usuario?",
        texto: () => "Vuelve a ingresar y a ver las empresas que tenía.",
        confirmar: "Sí, reactivar",
        listo: "Usuario reactivado.",
      },
      "cerrar-sesiones": {
        boton: "Cerrar sus sesiones",
        titulo: "¿Cerrar sus sesiones?",
        texto: () => "Tendrá que volver a ingresar en todos sus equipos. Su acceso no cambia.",
        confirmar: "Sí, cerrar sesiones",
        listo: "Sesiones cerradas.",
      },
      baja: {
        boton: "Dar de baja",
        titulo: "¿Dar de baja a este usuario?",
        texto: () =>
          "La cuenta no vuelve a entrar ni se puede reactivar; solo vuelve si se le invita de nuevo. El historial se conserva.",
        confirmar: "Sí, dar de baja",
        listo: "Usuario dado de baja.",
      },
    },
    motivoAccion: "Motivo (opcional)",
    bajaTexto:
      "Está dado de baja: no puede entrar. Para que vuelva, invítelo de nuevo; conserva su historial y se le da la empresa que elija.",
    invitarDeNuevo: "Invitar de nuevo",
  },
  instituciones: {
    titulo: "Instituciones",
    subtitulo:
      "Razones sociales que pueden usar el portal. Una institución deshabilitada deja de verse para todos sus usuarios en menos de 2 minutos.",
    columnaCodigo: "Código",
    columnaNombre: "Nombre",
    columnaEstado: "Estado",
    columnaActualizado: "Último cambio",
    habilitada: "Habilitada",
    deshabilitada: "Deshabilitada",
    habilitar: "Habilitar",
    deshabilitar: "Deshabilitar",
    renombrar: "Cambiar nombre",
    registrar: "Registrar institución",
    registrarTitulo: "Registrar una institución",
    registrarTexto:
      "Use el código exacto de la institución en SimplGo (por ejemplo COMFAM_CL). El portal no lo busca en SimplGo: si el código no coincide, sus usuarios no verán embarques.",
    renombrarTitulo: (codigo: string) => `Cambiar el nombre de ${codigo}`,
    codigo: "Código en SimplGo",
    codigoAyuda: "Mayúsculas, números y guion bajo.",
    nombre: "Nombre que verán los clientes",
    guardar: "Guardar",
    registrarYHabilitar: "Registrar y habilitar",
    confirmarDeshabilitarTitulo: (codigo: string) => `¿Deshabilitar ${codigo}?`,
    confirmarDeshabilitarTexto: (usuarios: number) =>
      `${plural(usuarios, "usuario deja", "usuarios dejan")} de ver esta institución. Sus accesos no se borran: vuelven si la habilita de nuevo.`,
    confirmarDeshabilitar: "Sí, deshabilitar",
    usuarios: (n: number) => plural(n, "usuario", "usuarios"),
    vacioTitulo: "Aún no hay instituciones registradas",
    vacioTexto: "Registre la primera para poder invitar a sus usuarios.",
    errores: {
      codigo: "Use el código de SimplGo: de 2 a 32 mayúsculas, números o guion bajo",
      nombre: "Escriba el nombre",
      existe: "Ese código ya está registrado: cambie su nombre desde la tabla",
    },
  },
  auditoria: {
    titulo: "Auditoría",
    subtitulo: "Cada acción de BVL y cada lectura, descarga o acceso negado de los clientes. Hora de Chile.",
    dia: "Día",
    columnaHora: "Hora",
    columnaQuien: "Quién",
    columnaQue: "Qué",
    columnaSobre: "Sobre",
    columnaDetalle: "Detalle",
    vacio: "No hubo actividad ese día.",
    cliente: "Cliente",
    tareaDiaria: "Tarea diaria",
    acciones: {
      invitar: "Invitó",
      reinvitar: "Invitó de nuevo",
      reenviar_invitacion: "Reenvió la invitación",
      suspender: "Suspendió",
      reactivar: "Reactivó",
      dar_de_baja: "Dio de baja",
      cambiar_perfil: "Cambió el perfil",
      conceder_institucion: "Agregó una empresa",
      quitar_institucion: "Quitó una empresa",
      cerrar_sesiones: "Cerró las sesiones",
      habilitar_institucion: "Habilitó la institución",
      deshabilitar_institucion: "Deshabilitó la institución",
      suspension_automatica: "Suspensión automática",
    } as Record<string, string>,
    tipos: {
      lectura: "Consultó",
      descarga: "Descargó un documento",
      acceso_denegado: "Pidió algo que no puede ver",
      documento_no_disponible: "Pidió un documento no disponible",
      cambio_destinatarios: "Cambió los destinatarios de avisos",
    } as Record<string, string>,
    otro: (tipo: string) => `Otro (${tipo})`,
    recursos: {
      embarques: (lista: string) => `Embarques de ${lista}`,
      embarque: (clave: string) => `Embarque ${clave}`,
      documento: (clave: string, id: string) => `Documento ${id} del embarque ${clave}`,
      facturas: (lista: string) => `Facturas de ${lista}`,
      cargos: (clave: string) => `Cargos del embarque ${clave}`,
      destinatarios: (lista: string) => `Destinatarios de ${lista}`,
    },
    institucion: (codigo: string) => `Institución ${codigo}`,
    campos: {
      institucion: "empresa",
      perfil: "perfil",
      relacion: "relación",
      motivo: "motivo",
      antes: "antes",
      despues: "después",
      nombre: "nombre",
      cambios: "cambios",
      version: "versión",
    } as Record<string, string>,
  },
  noEncontrada: {
    titulo: "Esta página no existe",
    texto: "Revise la dirección o vuelva a la lista de usuarios.",
  },
};

export type Textos = typeof es;
